import { Link, Outlet, useLocation } from 'react-router-dom';
import { Link2, Smartphone, User, BookOpen } from 'lucide-react';

export default function MemberSettings() {
  const location = useLocation();

  const tabs = [
    {
      id: 'integrations',
      path: '/member-settings/integrations',
      label: 'Integrasjoner',
      icon: Link2,
      // Show for all members - they need to set up integrations
      show: true
    },
    {
      id: 'devices',
      path: '/member-settings/devices',
      label: 'Mine enheter',
      icon: Smartphone,
      show: true
    },
    {
      id: 'account',
      path: '/member-settings/account',
      label: 'Konto',
      icon: User,
      show: true
    },
    {
      id: 'documentation',
      path: '/member-settings/documentation',
      label: 'Dokumentasjon',
      icon: BookOpen,
      show: true
    },
  ];

  const visibleTabs = tabs.filter(tab => tab.show);
  const currentPath = location.pathname;
  const activeTab = visibleTabs.find(tab => currentPath.startsWith(tab.path))?.id || 'integrations';

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Innstillinger</h1>
        <p className="mt-1 text-sm text-gray-500">
          Administrer dine innstillinger og integrasjoner
        </p>
      </div>

      {/* Tab Navigation */}
      <div className="bg-white rounded-lg shadow-sm border">
        <div className="border-b">
          <nav className="flex flex-wrap -mb-px">
            {visibleTabs.map((tab) => {
              const Icon = tab.icon;
              const isActive = activeTab === tab.id;

              return (
                <Link
                  key={tab.id}
                  to={tab.path}
                  className={`px-4 py-3 text-sm font-medium border-b-2 transition-colors flex items-center gap-2 ${
                    isActive
                      ? 'border-kf-primary text-kf-primary'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  <Icon size={18} />
                  {tab.label}
                </Link>
              );
            })}
          </nav>
        </div>
      </div>

      {/* Content */}
      <Outlet />
    </div>
  );
}
